/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner
 */
export interface PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner {
    /**
     * 
     * @type {boolean}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner
     */
    dateBased?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner
     */
    timeBased?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner
     */
    durationEstimated?: boolean;
}

/**
 * Check if a given object implements the PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner interface.
 */
export function instanceOfPartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInnerFromJSON(json: any): PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner {
    return PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInnerFromJSONTyped(json, false);
}

export function PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dateBased': !exists(json, 'dateBased') ? undefined : json['dateBased'],
        'timeBased': !exists(json, 'timeBased') ? undefined : json['timeBased'],
        'durationEstimated': !exists(json, 'durationEstimated') ? undefined : json['durationEstimated'],
    };
}

export function PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInnerToJSON(value?: PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dateBased': value.dateBased,
        'timeBased': value.timeBased,
        'durationEstimated': value.durationEstimated,
    };
}

